<!-- MODAL Agregar/ver retorno -->
<div mdbModal #agregarRetorno="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1"
    role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel" *ngIf="mode === 'ADD'">
                    Agregar retorno de mermas
                </h4>
                <h4 class="modal-title w-100 text-left" id="myModalLabel" *ngIf="mode === 'VIEW'">
                    Ver retorno de mermas
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="agregarRetorno.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <form autocomplete="off" [formGroup]="formHeader" [ngClass]="{disabledContent: !enableContent}">
                    <div class="row">
                        <div class="col" style="max-width: 300px;">
                            <div class="md-form mb-0">
                                <mdb-select [options]="optionsChofer" [multiple]="false" [filterEnabled]="true"
                                    [highlightFirst]="false" placeholder="Seleccionar Chofer" formControlName="chofer">
                                </mdb-select>
                                <label>Chofer</label>
                                <div *ngIf="
                                    formHeader.get('chofer').invalid &&
                                    (formHeader.get('chofer').dirty ||
                                    formHeader.get('chofer').touched)
                                    ">
                                    <mdb-error *ngIf="formHeader.get('chofer').hasError('required')">
                                        Ingrese chofer
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col" style="max-width: 300px;">
                            <div class="md-form mb-0">
                                <mdb-select [options]="optionsCamion" [multiple]="false" [filterEnabled]="true"
                                    [highlightFirst]="false" placeholder="Seleccionar Camión" formControlName="camion">
                                </mdb-select>
                                <label>Camión</label>
                                <div *ngIf="
                                    formHeader.get('camion').invalid &&
                                    (formHeader.get('camion').dirty ||
                                    formHeader.get('camion').touched)
                                    ">
                                    <mdb-error *ngIf="formHeader.get('camion').hasError('required')">
                                        Ingrese camión
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col" style="max-width: 200px;">
                            <div class="md-form mb-0">
                                <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Fecha'"
                                    formControlName="fecha" #datePicker>
                                </mdb-date-picker>
                                <div *ngIf="
                                    formHeader.get('fecha').invalid &&
                                    (formHeader.get('fecha').dirty ||
                                    formHeader.get('fecha').touched)
                                    ">
                                    <mdb-error *ngIf="formHeader.get('fecha').hasError('required')">
                                        Ingrese fecha
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col" style="max-width: 300px;">
                            <div class="md-form mb-0">
                                <input value="" type="text" id="rutCliente" class="form-control" placeholder="" required
                                    #rutCliente formControlName="rutCliente" formatRut />
                                <label for="rutCliente">RUT Cliente</label>
                                <div *ngIf="
                                        formHeader.get('rutCliente').invalid &&
                                        (formHeader.get('rutCliente').dirty ||
                                        formHeader.get('rutCliente').touched)
                                        ">
                                    <mdb-error *ngIf="formHeader.get('rutCliente').hasError('required')">
                                        Ingrese rut cliente
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div class="col d-flex">
                            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                                (click)="openModalSeleccionarcliente()">
                                <mdb-icon fas icon="search"></mdb-icon>
                            </button>
                            <h6 class="text-info" style="display: contents;" *ngIf="cliente">
                                {{ cliente.razon_social }}
                            </h6>
                        </div>
                        <div class="col" style="max-width: 300px;">
                            <div class="md-form mb-0">
                                <mdb-select [options]="optionsSucursal" [multiple]="false" [filterEnabled]="true"
                                    [highlightFirst]="false" placeholder="Seleccionar sucursal"
                                    formControlName="sucursal"></mdb-select>
                                <label>Sucursal</label>
                                <div *ngIf="
                                    formHeader.get('sucursal').invalid &&
                                    (formHeader.get('sucursal').dirty ||
                                    formHeader.get('sucursal').touched)
                                    ">
                                    <mdb-error *ngIf="formHeader.get('sucursal').hasError('required')">
                                        Ingrese sucursal
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col" style="max-width: 300px;">
                            <div class="md-form mb-0">
                                <mdb-select [options]="optionsPlaca" [multiple]="true" [filterEnabled]="true"
                                    [highlightFirst]="false" placeholder="Seleccionar placa" formControlName="placa">
                                </mdb-select>
                                <label>Placa</label>
                            </div>
                        </div>
                        <div class="col">
                            <div class="md-form mb-0">
                                <input value="" type="text" id="fichaTec" class="form-control"
                                    placeholder="Escribir aqui" required #fichaTec formControlName="fichaTecnica" />
                                <label for="fichaTec">Ficha técnica</label>
                            </div>
                        </div>
                    </div> -->
                    <div class="row">
                        <div class="col" style="max-width: 300px;">
                            <div class="md-form mb-0">
                                <mdb-select [options]="optionsTipoIngreso" [filterEnabled]="true"
                                    [highlightFirst]="false" placeholder="Seleccionar tipo de ingreso"
                                    formControlName="tipoIngreso"></mdb-select>
                                <label>Ingreso por: </label>
                                <div *ngIf="
                                    formHeader.get('tipoIngreso').invalid &&
                                    (formHeader.get('tipoIngreso').dirty ||
                                    formHeader.get('tipoIngreso').touched)
                                    ">
                                    <mdb-error *ngIf="formHeader.get('tipoIngreso').hasError('required')">
                                        Ingrese tipo ingreso
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="esTipoIngresoProducto()" class="col dato">
                            <Strong class="title">Total</Strong>
                            <span class="value">$ {{monto_total | numerico}}</span>
                        </div>
                        <div *ngIf="esTipoIngresoDocumento()" class="col" style="max-width: 300px;">
                            <div class="md-form mb-0">
                                <input value="" type="text" id="totalCabecera" class="form-control" placeholder=""
                                    formControlName="totalCabecera" #totalCabecera monto />
                                <label for="totalCabecera">Total</label>
                                <div *ngIf="
                                formHeader.get('totalCabecera').invalid &&
                                (formHeader.get('totalCabecera').dirty ||
                                formHeader.get('totalCabecera').touched)
                                ">
                                    <mdb-error
                                        *ngIf="formHeader.get('totalCabecera').hasError('required') || formHeader.get('totalCabecera').hasError('min')">
                                        Ingrese total
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row" *ngIf="formHeader.get('tipoIngreso').value === 1"> -->
                    <!-- *ngIf="esTipoIngresoDocumento()" -->
                    <div class="row">
                        <div class="col">
                            <div class="md-form mb-0">
                                <input value="" type="text" id="glosaTotal" class="form-control"
                                    placeholder="Escribir aqui" #glosaTotal formControlName="glosa" />
                                <label for="glosaTotal">Glosa</label>
                                <!-- <div *ngIf="
                                    formHeader.get('glosa').invalid &&
                                    (formHeader.get('glosa').dirty ||
                                    formHeader.get('glosa').touched)
                                    ">
                                    <mdb-error *ngIf="formHeader.get('glosa').hasError('required')">
                                        Ingrese glosa
                                    </mdb-error>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </form>

                <ng-container *ngIf="mode === 'ADD'" [ngClass]="{disabledContent: !enableContent}">
                    <form autocomplete="off" [formGroup]="formProductos">
                        <ng-container *ngIf="esTipoIngresoProducto()">
                            <div class="row">
                                <div class="col" style="max-width: 300px;">
                                    <div class="md-form mb-0">
                                        <input value="" type="text" id="codProduc" class="form-control" placeholder=""
                                            formControlName="sku" required #codProduc />
                                        <label for="codProduc">Código de producto</label>
                                        <div *ngIf="
                                    formProductos.get('sku').invalid &&
                                    (formProductos.get('sku').dirty ||
                                    formProductos.get('sku').touched)
                                    ">
                                            <mdb-error *ngIf="formProductos.get('sku').hasError('required')">
                                                Ingrese sku
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                                <div class="col d-flex">
                                    <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                                        (click)="openModalSeleccionarProducto()">
                                        <mdb-icon fas icon="search"></mdb-icon>
                                    </button>
                                    <h6 class="text-info" style="display: contents;" *ngIf="productoSeleccionado">
                                        {{ productoSeleccionado.descripcion}}
                                    </h6>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col" style="max-width: 300px;">
                                    <div class="md-form mb-0">
                                        <mdb-select [options]="optionsFormato" [filterEnabled]="true"
                                            [highlightFirst]="false" formControlName="formato"
                                            placeholder="Seleccionar formato">
                                        </mdb-select>
                                        <label>Formato</label>
                                        <div *ngIf="
                                    formProductos.get('formato').invalid &&
                                    (formProductos.get('formato').dirty ||
                                    formProductos.get('formato').touched)
                                    ">
                                            <mdb-error *ngIf="formProductos.get('formato').hasError('required')">
                                                Ingrese formato
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                                <div class="col" style="max-width: 300px;">
                                    <div class="md-form mb-0">
                                        <input value="" type="text" id="cantidad" class="form-control" placeholder=""
                                            required #cantidad formControlName="cantidad" monto />
                                        <label for="cantidad">Cantidad</label>
                                        <div *ngIf="
                                    formProductos.get('cantidad').invalid &&
                                    (formProductos.get('cantidad').dirty ||
                                    formProductos.get('cantidad').touched)
                                    ">
                                            <mdb-error *ngIf="formProductos.get('cantidad').hasError('required')">
                                                Ingrese cantidad
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                                <div class="col" style="max-width: 300px;">
                                    <div class="md-form mb-0">
                                        <input value="" type="text" id="cantidad" class="form-control" placeholder=""
                                            formControlName="precio" required #cantidad monto />
                                        <label for="cantidad">Precio</label>
                                        <div *ngIf="
                                    formProductos.get('precio').invalid &&
                                    (formProductos.get('precio').dirty ||
                                    formProductos.get('precio').touched)
                                    ">
                                            <mdb-error *ngIf="formProductos.get('precio').hasError('required')">
                                                Ingrese precio
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col dato">
                                <Strong class="title">Total</Strong>
                                <span class="value">$ {{monto_total | numerico}}</span>
                            </div> -->
                                <div class="col dato">
                                    <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect
                                        (click)="agregarProducto()">
                                        Agregar producto
                                    </button>
                                </div>
                            </div>
                            <!-- <div class="row mb-2" *ngIf="formHeader.get('tipoIngreso').value === 2"> -->
                            <!-- <div class="row mb-2" *ngIf="esTipoIngresoProducto()">
                        <div class="col">
                            <div class="md-form mb-0">
                                <input value="" type="text" id="glosaTotal" class="form-control"
                                    placeholder="Escribir aqui" #glosaTotal formControlName="glosa" />
                                <label for="glosaTotal">Glosa</label>
                            </div>
                        </div>
                    </div> -->
                        </ng-container>
                    </form>
                </ng-container>

                <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner>

                <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaProductos?.length > 0">
                    <thead class="grey lighten-2">
                        <tr>
                            <th scope="col">Código</th>
                            <th scope="col">Descripción</th>
                            <th scope="col">Cantidad</th>
                            <th scope="col">Formato</th>
                            <th scope="col">Precio</th>
                            <th scope="col">Total</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let producto of listaProductos">
                        <tr>
                            <td>{{producto.sku}}</td>
                            <td>{{producto.descripcion}}</td>
                            <td>{{producto.cantidad | numerico}}</td>
                            <td>{{producto.formato_nombre}}</td>
                            <td>$ {{producto.precio_venta | numerico}}</td>
                            <td>$ {{producto.monto_total | numerico}}</td>
                        </tr>
                    </tbody>
                    <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                        *ngIf="listaProductosAll?.length > 0"></app-pagination>
                </table>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
                    (click)="agregarRetorno.hide()" mdbWavesEffect>
                    Cerrar
                </button>
                <button *ngIf="mode === 'ADD'" type="button" class="btn btn-secondary waves-light" mdbWavesEffect
                    (click)="guardar()">
                    Guardar
                </button>
            </div>
        </div>
    </div>
</div>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" queryType="ONLY_RUT" (onSelectSingle)="onClienteSeleccionado($event)"
    (onNotFound)="onClienteNoEncontrado()">
</app-modal-seleccionar-cliente>

<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto (onSelect)="onProductoSeleccionado($event)" (onNotFound)="onProductoNoEncontrado()">
</app-modal-seleccionar-producto>